import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Grid,
  CircularProgress,
} from '@mui/material';
import { trainersAPI } from '../services/api';
import { useNotify } from '../context/NotifyContext';
import errorMessage from '../utils/errorMessage';

const AddTrainerModal = ({ open, onClose, onSuccess }) => {
  const notify = useNotify();
  const [formData, setFormData] = useState({
    business_name: '',
    trainer_name: '',
    phone: '',
    email: '',
    emergency_phone: '',
    address: '',
    city: '',
    state: '',
    zip_code: '',
    specialties: '',
    notes: '',
  });
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setFormData({
      business_name: '',
      trainer_name: '',
      phone: '',
      email: '',
      emergency_phone: '',
      address: '',
      city: '',
      state: '',
      zip_code: '',
      specialties: '',
      notes: '',
    });
    setLoading(false);
    onClose();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await trainersAPI.create(formData);
      if (onSuccess) {
        onSuccess(response.data);
      }
      handleClose();
    } catch (error) {
      console.error('Error creating trainer:', error);
      notify.error(errorMessage(error, 'Error creating trainer'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <DialogTitle>Add New Trainer</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                  size="small"
                name="business_name"
                label="Business Name"
                value={formData.business_name}
                onChange={handleInputChange}
                fullWidth
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                  size="small"
                name="trainer_name"
                label="Trainer Name"
                value={formData.trainer_name}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                  size="small"
                name="phone"
                label="Phone"
                value={formData.phone}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                  size="small"
                name="email"
                label="Email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                  size="small"
                name="emergency_phone"
                label="Emergency Phone"
                value={formData.emergency_phone}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                  size="small"
                name="address"
                label="Address"
                value={formData.address}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                  size="small"
                name="city"
                label="City"
                value={formData.city}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                  size="small"
                name="state"
                label="State"
                value={formData.state}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                  size="small"
                name="zip_code"
                label="Zip Code"
                value={formData.zip_code}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                  size="small"
                name="specialties"
                label="Specialties"
                value={formData.specialties}
                onChange={handleInputChange}
                fullWidth
                placeholder="e.g., Reining, Cutting, Western Pleasure, Starting Colts"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                  size="small"
                name="notes"
                label="Notes"
                value={formData.notes}
                onChange={handleInputChange}
                multiline
                rows={3}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTrainerModal;

